import { CloseOutlined, DownloadOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, message, Modal, Table, Tag } from "antd";
import { FileList, RebateAndCogsData } from "../../data";
import { useState } from "react";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from 'xlsx';

const AutomationExceptionFile = ({
  open,
  hide,
  fileType,
  selectedFileData,
  isLoading,
  getSelectedCogsData,
  getRebatFile,
  fileData,
  getAllUploadedFiles
}) => {
  const [pagination, setPagination] = useState(10);
  const [rebateApproveLoading, setApproveRebateLoading] = useState(false);
  const [cogsApproveLoading, setApproveCogsLoading] = useState(false)
  const [cogsRejectLoading, setCogsRejectLoading] = useState(false)
  const [rebateRejectLoading, setRebateRejectLoading] = useState(false)

  const columns = [
    {
      title: "ID",
      dataIndex: "Id",
      key: "Id",
    },
    {
      title: "File ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Customer Group",
      dataIndex: "customerGroup",
      key: "customerGroup",
    },
     {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Account Number",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      key: "accountName",
    },
    //  {
    //   title: "Total Rebate Amount",
    //   dataIndex: "totalRebateamount",
    //   key: "totalRebateamount",
    // },
    {
      title: "SYS Total RX",
      dataIndex: "sys_Total_Rx",
      key: "sys_Total_Rx",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Speciality",
      dataIndex: "sys_Specialty",
      key: "sys_Specialty",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic Rx",
      dataIndex: "sys_Generic_Rx",
      key: "sys_Generic_Rx",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "MCK GCR %",
      dataIndex: "gcrPer",
      key: "gcrPer",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title: "MCK SGCR %",
      dataIndex: "sgcrPer",
      key: "sgcrPer",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title: "MCK GPR %",
      dataIndex: "gprPer",
      key: "gprPer",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS SGCR %",
      dataIndex: "sys_SGCR_Percentage",
      key: "sys_SGCR_Percentage",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS GCR %",
      dataIndex: "sys_GCR_Percentage",
      key: "sys_GCR_Percentage",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS GPR %",
      dataIndex: "sys_GPR_Percentage",
      key: "sys_GPR_Percentage",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Generic GCR Rebate %",
      dataIndex: "genericsgcrper",
      key: "genericsgcrper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Generic GPR Rebate %",
      dataIndex: "genericgprper",
      key: "genericgprper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Brand GCR Rebate %",
      dataIndex: "brandsgcrper",
      key: "brandsgcrper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Brand GPR Rebate %",
      dataIndex: "brandgprper",
      key: "brandgprper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GCR  %",
      dataIndex: "sys_generic_sgcr_per",
      key: "sys_generic_sgcr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GPR  %",
      dataIndex: "sys_generic_gpr_per",
      key: "sys_generic_gpr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Brand GCR  %",
      dataIndex: "sys_brand_sgcr_per",
      key: "sys_brand_sgcr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Brand GPR  %",
      dataIndex: "sys_brand_gpr_per",
      key: "sys_brand_gpr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GCR Amount",
      dataIndex: "eligiblegenericsgcr",
      key: "eligiblegenericsgcr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GPR Amount",
      dataIndex: "eligiblegenericgpr",
      key: "eligiblegenericgpr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "SYS Brand GCR Amount",
      dataIndex: "eligiblebrandsgcr",
      key: "eligiblebrandsgcr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "SYS Brand GPR Amount",
      dataIndex: "eligiblebrandgpr",
      key: "eligiblebrandgpr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Generic GCR Amount",
      dataIndex: "earned_gcr_generic_file",
      key: "earned_gcr_generic_file",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Generic GPR Amount",
      dataIndex: "earned_gpr_generic_file",
      key: "earned_gpr_generic_file",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Brand GCR Amount",
      dataIndex: "earned_gcr_brand_file",
      key: "earned_gcr_brand_file",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Brand GPR Amount",
      dataIndex: "earned_gpr_brand_file",
      key: "earned_gpr_brand_file",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Exception Reason",
      dataIndex: "exceptionReason",
      key: "exceptionReason",
    },
    {
      title: "Action",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        if (status === "Rejected") {
          return <Tag color="red">Rejected</Tag>;
        } else if (status === "Approved") {
          return <Tag color="green">Approved</Tag>;
        } else if (status === "Pending" || status === "Uploaded") {
          return (
            <div className="flex gap-2">
              <Button
                type="primary"
                size="small"
                loading={rebateApproveLoading === record.Id}
                onClick={() => handleApprove(record)}
              >
                Approve
              </Button>
              <Button
                danger
                size="small"
                loading={rebateRejectLoading === record.Id}
                onClick={() => handleReject(record)}
              >
                Reject
              </Button>
            </div>
          );
        } else {
          return <Tag color="default">{status || "Unknown"}</Tag>;
        }
      },
    }
  ];

  const cogsColumn = [
    {
      title: "File ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Primary Account",
      dataIndex: "PRIMARY_ACCT",
      key: "PRIMARY_ACCT",
    },
    
    {
      title: "Account Id",
      dataIndex: "ACCT_ID",
      key: "ACCT_ID",
    },
    {
      title: "Lock ID",
      dataIndex: "INA_LOC_ID",
      key: "INA_LOC_ID",
      render: (value) => value === null || value === undefined ? "null" : value
    },
    {
      title:"Store Name",
      dataIndex:"STORE_NAME",
      key:"STORE_NAME"
    },
    {
      title:"MCK RX Amount",
      dataIndex:"RX_AMT",
      key:"RX_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK Generic RX Amount",
      dataIndex:"GRX_AMT",
      key:"GRX_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK HIV Amount",
      dataIndex:"HIV_AMT",
      key:"HIV_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK GCR %",
      dataIndex:"GCR",
      key:"GCR",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal RX Amount",
      dataIndex:"Portal_RX",
      key:"Portal_RX",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal Generic RX Amount",
      dataIndex:"Portal_GRX",
      key:"Portal_GRX",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title:"Portal HIV Amount",
      dataIndex:"Portal_HIV",
      key:"Portal_HIV",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal GCR %",
      dataIndex:"Portal_GCR",
      key:"Portal_GCR",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"RX DIFF",
      dataIndex:"RX_DIFF",
      key:"RX_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"Generic RX DIFF",
      dataIndex:"GRX_DIFF",
      key:"GRX_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"GCR DIFF",
      dataIndex:"GCR_DIFF",
      key:"GCR_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"HIV DIFF",
      dataIndex:"HIV_DIFF",
      key:"HIV_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"Quarter Label",
      dataIndex:"QuarterLabel",
      key:"QuarterLabel",
    },
    {
      title: "Exception Reason",
      dataIndex: "ErrorReasons",
      key: "ErrorReasons",
    },
    {
      title: "Action",
      dataIndex: "Status",
      key: "action",
      render: (status, record) => {
        if (status === "Rejected") {
          return <Tag color="red">Rejected</Tag>;
        } else if (status === "Approved") {
          return <Tag color="green">Approved</Tag>;
        } else if (status === "Pending" || status === "Uploaded") {
          return (
            <div className="flex gap-2">
              <Button
                type="primary"
                size="small"
                onClick={() => handleApproveCogs(record)}
              >
                Approve
              </Button>
              <Button
                danger
                size="small"
                onClick={() => handleRejectCogs(record)}
              >
                Reject
              </Button>
            </div>
          );
        } else {
          return <Tag color="default">{status || "Unknown"}</Tag>;
        }
      },
    }

  ];

  const handleApproveCogs = async (record) => {
    if (!record?.FileId) {
      return;
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/exceptionCOGS/${record?.FileId}/${record?.ACCT_ID}/approve`);
      getSelectedCogsData(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      getAllUploadedFiles()
    }
  }
  const handleRejectCogs = async (record) => {
    if (!record?.FileId) {
      return;
    }
    const payload = {
      reason: record?.ErrorReasons
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/exceptionCOGS/${record?.FileId}/${record?.ACCT_ID}/reject`, payload);
      getSelectedCogsData(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      getAllUploadedFiles()
    }
  }

  const handleApprove = async (record) => {
    if (!record?.Id) {
      return;
    }
    setApproveRebateLoading(record.Id)
    const payload = {
      reason: record?.exceptionReason
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/rebate-exceptions/approve/${record?.Id}`, payload);
      getRebatFile(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      setApproveRebateLoading(false)
      getAllUploadedFiles()
    }
  }

  const handleExportCOgs = async () => {
    const exportData = selectedFileData;
    const headers = [
      "File ID",
      "Primary Account",
      "Account Id",
      "Lock ID",
      "Store Name",
      "MCK RX Amount",
      "MCK GRX Amount",
      "MCK HIV Amount",
      "MCK GCR %",
      "Portal RX Amount",
      "Portal Generic RX Amount",
      "Portal HIV Amount",
      "Portal GCR %",
      "RX DIFF",
      "GRX DIFF",
      "HIV DIFF",
      "GCR DIFF",
      // "Current BRX COG",
      // "BRX COG Base",
      // "Final COGs",
      // "Preliminary BRX COG",
      // "Base DSO",
      // "DSO",
      // "DSO ADJ",
      // "Pay Method",
      // "Pay Method ADJ",
      // "CUR BRX File",
      // "CUR BRX DB",
      // "COG File",
      // "COG DB",
      // "GCR File",
      // "GCR DB",
      "Exception Reason",
      // "Status"
    ];

    const rows = exportData.map((item) => [
      item?.FileId,
      item?.PRIMARY_ACCT,
      item?.ACCT_ID,
      // item?.LockID === null ? "null" : item?.LockID,
      item?.INA_LOC_ID === null ? "null" : item?.INA_LOC_ID,
      item?.STORE_NAME,
      item?.RX_AMT,
      item?.GRX_AMT,
      item?.HIV_AMT,
      item?.GCR,
      item?.Portal_RX,
      item?.Portal_GRX,
      item?.Portal_HIV,
      item?.Portal_GCR,
      item?.RX_DIFF,
      item?.GRX_DIFF,
      item?.HIV_DIFF,
      item?.GCR_DIFF,
      // item?.Current_BRX_COG,
      // item?.BRX_COG_BASE,
      // item?.Final_COGs,
      // item?.Preliminary_BRX_COG,
      // item?.BASE_DSO,
      // item?.DSO,
      // item?.DSO_ADJ,
      // item?.PAY_METHOD,
      // item?.PAY_METHOD_ADJ,
      // item?.CUR_BRX_File,
      // item?.CUR_BRX_DB,
      // item?.COG_File,
      // item?.COG_DB,
      // item?.GCR_File,
      // item?.GCR_DB,
      item?.ErrorReasons,
      // item?.Status
    ]);

    // Combine headers and data
    const worksheetData = [headers, ...rows];

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "COGS file Report");

    // Export the Excel file
    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-");
    XLSX.writeFile(workbook, `COGSExceptions_${timestamp}.xlsx`);
  };

  const handleReject = async (record) => {
    if (!record?.Id) {
      return;
    }
    setRebateRejectLoading(record?.Id)
    const payload = {
      reason: record?.exceptionReason
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/rebate-exceptions/reject/${record?.Id}`, payload);
      getRebatFile(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      setRebateRejectLoading(false)
      getAllUploadedFiles()
    }
  }

  // const handleExportRebate = async () => {
  //       const exportData = selectedFileData;
  //       const headers = [
  //         "Account Number",
  //         "Account Name",
  //         "GCR Ratio",
  //         "SGCR Ratio",
  //         "GPR Ratio",
  //         "Eligible Generic SGCR",
  //         "Eligible Generic GPR",
  //         "Eligible Brand SGCR",
  //         "Eligible Brand GPR",
  //         "Earned GCR Generic File",
  //         "Earned GPR Generic File",
  //         "Earned GCR Brand File",
  //         "Earned GPR Brand File",
  //         "Exception Reason",
  //         "Status"
  //       ];

  //       const rows = exportData.map((item) => [
  //         item?.accountNumber,
  //         item?.accountName,
  //         item?.gcrPer,
  //         item?.sgcrPer,
  //         item?.gprPer,
  //         item?.eligiblegenericsgcr,
  //         item?.eligiblegenericgpr,
  //         item?.eligiblebrandsgcr,
  //         item?.eligiblebrandgpr,
  //         item?.earned_gcr_generic_file,
  //         item?.earned_gpr_generic_file,
  //         item?.earned_gcr_brand_file,
  //         item?.earned_gpr_brand_file,
  //         item?.exceptionReason,
  //         item?.status
  //       ]);

  //       // Combine headers and data
  //       const worksheetData = [headers, ...rows];

  //       // Create worksheet and workbook
  //       const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //       const workbook = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate file Report");

  //       // Export the Excel file
  //       const timestamp = new Date()
  //         .toISOString()
  //         .replace(/[:.]/g, "-");  
  //       XLSX.writeFile(workbook, `RebateExceptions_${timestamp}.xlsx`);
  //   };

  const handleExportRebate = async () => {
    const exportData = selectedFileData;

    const headers = [
      "Id",
      "File ID",
      "customer Group",
      "customer Name",
      "Account Number",
      "Account Name",
      "Email",
      "SYS Total RX",
      "SYS Speciality",
      "SYS Generic Rx",
      "MCK GCR %",
      "MCK GPR %",
      "MCK SGCR % ",
      "SYS GCR %",
      "SYS SGCR % ",
      "SYS GPR %",
      "MCK Generic GCR Rebate %",
      "MCK Generic GPR Rebate %",
      "MCK Brand GCR Rebate %",
      "MCK Brand GPR Rebate %",
      "SYS Generic GCR  %",
      "SYS Generic GPR  %",
      "SYS Brand GCR  %",
      "SYS Brand GPR  %",
      "MCK Generic GCR Amount",
      "MCK Generic GPR Amount",
      "MCK Brand GCR Amount",
      "MCK Brand GPR Amount",
      "SYS Generic GCR Amount",
      "SYS Generic GPR Amount",
      "SYS Brand GCR Amount",
      "SYS Brand GPR  Amount",
      // File vs System Percentages
      // "File GCR %",
      // "System GCR %",
      // "File SGCR %",
      // "System SGCR %",
      // "File GPR %",
      // "System GPR %",

      // // Granular Percentages
      // "File Generic SGCR %",
      // "System Generic SGCR %",
      // "File Generic GPR %",
      // "System Generic GPR %",
      // "File Brand SGCR %",
      // "System Brand SGCR %",
      // "File Brand GPR %",
      // "System Brand GPR %",

      // // Amounts
      // "File Generic SGCR $",
      // "System Generic SGCR $",
      // "File Generic GPR $",
      // "System Generic GPR $",
      // "File Brand SGCR $",
      // "System Brand SGCR $",
      // "File Brand GPR $",
      // "System Brand GPR $",

      // // Eligible
      // "Eligible Generic SGCR",
      // "Eligible Generic GPR",
      // "Eligible Brand SGCR",
      // "Eligible Brand GPR",

      "Exception Reason"
    ];

    const rows = exportData.map((item) => [
      item?.Id,
      item?.FileId,
      item?.customerGroup,
      item?.customerName,
      item?.accountNumber,
      item?.accountName,
      item?.email,

      item?.sys_Total_Rx,
      item?.sys_Specialty,
      item?.sys_Generic_Rx,

      // File vs System Percentages
      item?.gcrPer,
      item?.gprPer,
      item?.sgcrPer,
      item?.sys_GCR_Percentage,
      item?.sys_SGCR_Percentage,
      item?.sys_GPR_Percentage,

      // Granular Percentages
      item?.genericsgcrper,
      item?.genericgprper,
      item?.brandsgcrper,
      item?.brandgprper,


      item?.sys_generic_sgcr_per,
      item?.sys_generic_gpr_per,
      item?.sys_brand_sgcr_per,
      item?.sys_brand_gpr_per,

      // Amounts
      item?.earned_gcr_generic_file,
      // item?.sys_generic_sgcr_amt,
      item?.earned_gpr_generic_file,
      // item?.sys_generic_gpr_amt,
      item?.earned_gcr_brand_file,
      // item?.sys_brand_sgcr_amt,
      item?.earned_gpr_brand_file,
      // item?.sys_brand_gpr_amt,

      // Eligible
      item?.eligiblegenericsgcr,
      item?.eligiblegenericgpr,
      item?.eligiblebrandsgcr,
      item?.eligiblebrandgpr,

      item?.exceptionReason
    ]);

    const worksheetData = [headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate Comparison");

    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    XLSX.writeFile(workbook, `RebateExceptions_${timestamp}.xlsx`);
  };

  return (
    <Modal
      style={{ marginTop: "-60px" }}
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
          }}
        >
          Audit Comparison
        </div>
      }
      open={open}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="user-modal"
      closeIcon={<CloseOutlined />}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            borderTop: "1px solid #f0f0f0",
            padding: "16px 0",
            marginTop: "24px",
          }}
        ></div>
      }
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <div className="flex justify-between items-center mt-3">
        <div>
          <span className="cardtitle ">{fileData?.FileName}</span>
        </div>
        {
          (fileType === "Rebate" || fileType === "COGS") && (
            <div>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => {
                  fileType === "Rebate" ?
                    handleExportRebate()
                    : handleExportCOgs()
                }
                }
                className="w-[100px] ml-4"
              >
                Export
              </Button>

            </div>
          )
        }
      </div>
      <div style={{ marginTop: "24px" }}>
        <Table
          columns={fileType === "COGS" ? cogsColumn : columns}
          dataSource={selectedFileData}
          scroll={{ x: "max-content" }}
          rowKey="id"
          size="middle"
          loading={isLoading}
          className="custom-table user-tbl"
          pagination={{
            pageSize: pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} accounts`,
            onShowSizeChange: (current, size) => {
              setPagination(size);
            },
          }}
        />
      </div>
      <style>
        {`.custom-country-dropdown {
          width: 220px !important; 
          }
          .remove-caret .ant-select-selection-search input {
  caret-color: transparent !important;
  // color: transparent !important;     
  background-color: transparent;       
}     
`}
      </style>
    </Modal>
  );
};

export default AutomationExceptionFile;
